import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { ModalActionsComponent } from '@app/components';
import { getLoaderBtn } from '@app/store/actions';
import { PolicyForm as AddPolicyForm } from '../policy';
import { IRule, IGlobalState} from '@app/models';
import { policiesAuthService } from '@app/services';
import { onPressEnterModal, genericErrorToast } from '@app/helpers';
import { prepareData } from '../policy/methods';

interface IProps {
    toggleModal: Function;
    handleRefresh: Function;
}

export const AddPolicyDialog = (props: IProps) => {
    const { toggleModal, handleRefresh } = props;

    const [disabledAdding, isAddingDisabled] = useState<boolean>(true);
    const [defaultPolicy, setDefaultPolicy] = useState<boolean>(false);
    const [policyName, setPolicyName] = useState<string>('');

    const mainRule: IRule = useSelector((state: IGlobalState) => state.policiesAuth.mainRule);

    const { translation } = useTypedTranslation();
    const dispatch = useDispatch();

    const handleSubmitBtn = () => {
        dispatch(getLoaderBtn(true));
        isAddingDisabled(true);
        policiesAuthService.addPolicy(prepareData(mainRule, policyName, defaultPolicy), handleError, handleSuccess);
    };

    const handleCancel = () => {
        toggleModal(false);
    };

    const handleValidation = (isValid: boolean) => {
        isValid
            ? isAddingDisabled(false)
            : isAddingDisabled(true);
    };

    const handleDefaultPolicy = (isDefault: boolean) => {
        setDefaultPolicy(isDefault);
    };

    const handlePolicyName = (name: string) => {
        setPolicyName(name);
    };

    const handleSuccess = () => {
        dispatch(getLoaderBtn(false));
        toggleModal(false);
        handleRefresh(true);
    };

    const handleError = (error: any) => {
        genericErrorToast(error);

        dispatch(getLoaderBtn(false));
    };

    return (
        <>
            <AddPolicyForm
                handleValidation={handleValidation}
                isDefault={handleDefaultPolicy}
                policyName={handlePolicyName}
                isEdit={false}
            />
            <ModalActionsComponent
                primaryBtn={translation('ADD_POLICY')}
                secondaryBtn={translation('CANCEL')}
                onClickPrimary={handleSubmitBtn}
                onClickSecondary={handleCancel}
                disabled={disabledAdding}
                id='addPolicy'
            />
        </>
    );
};
